
;(function($, window, document) {

  const inputs = document.querySelectorAll('.form input, .form textarea');

  inputs.forEach((input) => {

    // wrap each input in a div
    const wrapper = document.createElement('div');
    wrapper.className = 'input-wrapper';
    input.parentNode?.insertBefore(wrapper, input);
    wrapper.appendChild(input);

  });

  // Fix iOS hubspot bug
  document.addEventListener('focusout', (e: any) => {
    if (e.target.tagName === 'SELECT' && e.target.closest('.hs-form')) {
      // Delay to let iOS finish selecting
      setTimeout(() => {
        // Only refocus if user didn't move intentionally
        // console.log('foc refocus check', document.activeElement, document.body);
        if (!document.activeElement || document.activeElement === document.body) {
          e.target.focus();
        }
      }, 0);
    }
  });

// @ts-ignore
})(jQuery, window, document);

